"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineObject14ToJSON = exports.InlineObject14FromJSONTyped = exports.InlineObject14FromJSON = void 0;
var runtime_1 = require("../runtime");
function InlineObject14FromJSON(json) {
    return InlineObject14FromJSONTyped(json, false);
}
exports.InlineObject14FromJSON = InlineObject14FromJSON;
function InlineObject14FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'gameId': json['gameId'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'steamAppId': !(0, runtime_1.exists)(json, 'steamAppId') ? undefined : json['steamAppId'],
        'steamName': !(0, runtime_1.exists)(json, 'steamName') ? undefined : json['steamName'],
        'shortDescription': !(0, runtime_1.exists)(json, 'shortDescription') ? undefined : json['shortDescription'],
        'genres': !(0, runtime_1.exists)(json, 'genres') ? undefined : json['genres'],
        'developers': !(0, runtime_1.exists)(json, 'developers') ? undefined : json['developers'],
        'publishers': !(0, runtime_1.exists)(json, 'publishers') ? undefined : json['publishers'],
        'releaseDate': !(0, runtime_1.exists)(json, 'releaseDate') ? undefined : json['releaseDate'],
        'steamHeaderImage': !(0, runtime_1.exists)(json, 'steamHeaderImage') ? undefined : json['steamHeaderImage'],
        'steamCapsuleImage': !(0, runtime_1.exists)(json, 'steamCapsuleImage') ? undefined : json['steamCapsuleImage'],
        'steamBackground': !(0, runtime_1.exists)(json, 'steamBackground') ? undefined : json['steamBackground'],
        'steamScreenshots': !(0, runtime_1.exists)(json, 'steamScreenshots') ? undefined : json['steamScreenshots'],
        'categories': !(0, runtime_1.exists)(json, 'categories') ? undefined : json['categories'],
        'recommendations': !(0, runtime_1.exists)(json, 'recommendations') ? undefined : json['recommendations'],
        'achievements': !(0, runtime_1.exists)(json, 'achievements') ? undefined : json['achievements'],
        'website': !(0, runtime_1.exists)(json, 'website') ? undefined : json['website'],
        'timeTrackedGame': !(0, runtime_1.exists)(json, 'timeTrackedGame') ? undefined : json['timeTrackedGame'],
    };
}
exports.InlineObject14FromJSONTyped = InlineObject14FromJSONTyped;
function InlineObject14ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'gameId': value.gameId,
        'name': value.name,
        'steamAppId': value.steamAppId,
        'steamName': value.steamName,
        'shortDescription': value.shortDescription,
        'genres': value.genres,
        'developers': value.developers,
        'publishers': value.publishers,
        'releaseDate': value.releaseDate,
        'steamHeaderImage': value.steamHeaderImage,
        'steamCapsuleImage': value.steamCapsuleImage,
        'steamBackground': value.steamBackground,
        'steamScreenshots': value.steamScreenshots,
        'categories': value.categories,
        'recommendations': value.recommendations,
        'achievements': value.achievements,
        'website': value.website,
        'timeTrackedGame': value.timeTrackedGame,
    };
}
exports.InlineObject14ToJSON = InlineObject14ToJSON;
